import React, { useState, useEffect } from "react";
import "./KYC.scss";
import {
  DocumentRead,
  getKYCData,
  idScan,
  thisIsMePhotoCompare,
  updateStatus,
} from "../../../util/API/KYC";
import {
  editUserDetails,
} from "../../../util/API/customers";
import KYCItem from "./KYCItem/KYCItem";
import KYCInformation from "./KYCInformation/KYCInformation";
import KYCNoItem from "./KYCNoItem/KYCNoItem";

function KYC({ selectedUser, selectedUserData, setSelectedUserData }) {
  const [addressImageSelected, setAddressImageSelected] = useState(null);
  const [idImageSelected, setIDImage] = useState(null);
  const [selfieSelected, setSelfieSelected] = useState(null);
  const [selectedImageType, setSelectedImageType] = useState("");
  const [infoVisible, setInfoVisible] = useState(false);
  const [idVisible, setIdVisible] = useState(false);
  const [addressVisible, setAddressVisible] = useState(false);
  const [licenseSelected, setLicenseSelected] = useState(false);
  const [kycData, setKycData] = useState(null);
  const [idStatus, setIdStatus] = useState("");
  const [addressStatus, setAddressStatus] = useState("");
  const [selfieStatus, setSelfieStatus] = useState("");
  const [userStatus, setUserStatus] = useState("");

  //dockeys
  const [personalIdImage, setPersonalIdImage] = useState("");
  const [addressImage, setAddressImage] = useState("");
  const [selfieImage, setSelfieImage] = useState("");
  const [displayMessage, setDisplayMessage] = useState(false);
  const displayPDF = !!selectedUserData.User.other4;

  useEffect(() => {
    const getKYC = async () => {
      try {
        const response = await getKYCData(selectedUserData.User.id);
        setKycData(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (selectedUserData.User.profilestatus == 2) {
      setUserStatus("Accepted");
    } else if (selectedUserData.User.profilestatus == 0) {
      setUserStatus("Rejected");
    } else {
      setUserStatus("Pending");
    }
    getKYC();
  }, []);

  useEffect(() => {
    setPersonalIdImage(kycData?.payload[1]?.body?.record?.Userkycdocs?.dockey);
    setAddressImage(kycData?.payload[2]?.body?.record?.Userkycdocs?.dockey);
    setSelfieImage(kycData?.payload[3]?.body?.record?.Userkycdocs?.dockey);
    setIdStatus(kycData?.payload[1]?.body?.record?.Userkycdocs?.verified);
    setAddressStatus(kycData?.payload[2]?.body?.record?.Userkycdocs?.verified);
    setSelfieStatus(kycData?.payload[3]?.body?.record?.Userkycdocs?.verified);
  }, [kycData]);
  const licenseImage = null;

  const readDocument = async (docid, docType) => {
    if (!docid) return;
    let response = await DocumentRead(docid);
    let doctext = response.ServiceData.doctext;
    if (docType === "address") setAddressImageSelected(doctext);
    if (docType === "personalID") setIDImage(doctext);
    if (docType === "selfie") setSelfieSelected(doctext);
    setSelectedImageType(docType);
  };

  const setStatus = async (document, status) => {
    document["userid"] = selectedUserData.User.id;
    document["verified"] = status;
    document["verificationdate"] = "";
    document["whomverified"] = 1;
    const response = await updateStatus(document);
    if (response.data.header.callStatus != 1) {
      return;
    }
    if (document.name === "identification") {
      setIdStatus(status);
    } else if (document.name === "address") {
      setAddressStatus(status);
    } else if (document.name === "selfie") {
      setSelfieStatus(status);
    }
  };

  const getStatus = (statusNum) => {
    if (statusNum == 1) {
      return "Accepted";
    } else if (statusNum == 0) {
      return "Pending";
    } else {
      return "Rejected";
    }
  };

  const classification = {
    address: "Proof of Address",
    selfie: "Selfie",
    SA_ID: "South African ID",
    Passport: "Passport",
    Refugee_ID: "Refugee Documentation",
    Aslyum_permit: "Asylum Permit",
  };

  const revalidate = async () => {
    // const apiResponse =
    //   kycData?.payload[1]?.body?.record?.Userkycdocs?.apiresponse;
    // if (!apiResponse) return;
    const docid = kycData?.payload[1]?.body?.record?.Userkycdocs?.docid;
    // const json = JSON.parse(apiResponse.replace(/&(amp;)*quot;/g, '"'));
    // console.log(json);

    let image = await DocumentRead(personalIdImage);
    image = image.ServiceData.doctext.split(",")[1];
    const doctype = kycData.payload[1].body.record.Userkycdocs.doctype;
    if (doctype === "SA_ID" || doctype === "Passport") {
      idScan(docid, selectedUser, image);
      if (doctype !== "SA_ID" && selfieImage) {
        let selfie = await DocumentRead(selfieImage);
        selfie = selfie.ServiceData.doctext.split(",")[1];
        const selfieId = kycData?.payload[3]?.body?.record?.Userkycdocs?.docid;
        thisIsMePhotoCompare(selfieId, selectedUser, image, selfie);
      }
    }
  };

  const validateUser = async (status) => {
    const kycData = await getKYCData(selectedUserData.User.id);
    const idStatus = kycData.payload[1].body.record.Userkycdocs.verified;
    const addressStatus = kycData.payload[2].body.record.Userkycdocs.verified;
    const selfieStatus = kycData.payload[3].body.record.Userkycdocs.verified;
    const verified = idStatus == 1 && addressStatus == 1 && selfieStatus == 1;
    if (status === 2) {
      if (verified) {
        //We are passing in displayPDF as the fourth param for the function because it lets us know if the user if true = s1security and false = not s1security
        const res = await editUserDetails(
          selectedUser,
          `profilestatus|${status}`,
          selectedUserData.Useremailaccount.emailAccount,
          displayPDF,
          selectedUserData.User.firstName
        );
        // if (res.payload.callStatus == 1) {
        //   sendSMS(
        //     selectedUserData.User.telephoneno,
        //     "Your SendIt documents have been approved. You may now complete transactions.",
        //     selectedUser,
        //     selectedUserData.User.countryid
        //   );
        //   setUserStatus("Accepted");
        //   setDisplayMessage(true);
        // }
      } else {
        alert("Please approve all documents before approving the user");
      }
    } else {
      if (verified) {
        alert("User may only be rejected if a document is rejected");
      } else {
        const res = await editUserDetails(
          selectedUser,
          `profilestatus|${status}`
        );
        // if (res.payload.callStatus == 1) {
        //   setUserStatus("Rejected");
        //   sendSMS(
        //     selectedUserData.User.telephoneno,
        //     "Your SendIt documents have been rejected. Contact support for information on how to get approval.",
        //     selectedUser,
        //     selectedUserData.User.countryid
        //   );
        //   setDisplayMessage(true);
        // }
      }
    }
  };

  const statusClass =
    userStatus === "Accepted"
      ? "status-accepted"
      : userStatus === "Rejected"
      ? "status-rejected"
      : "status-pending";

  return (
    <div>
      <div className="kyc-header">
        <p className="security-warning">
          SECURITY: This is PII data is confidential.
        </p>
        <div className="kyc-buttons">
          <button className="kyc-compare" onClick={revalidate}>
            Revalidate
          </button>
          <button className="kyc-compare">KYC Compare</button>
        </div>
      </div>
      <div className="kyc-container">
        <div className="KYC-ID-box">
          KYC Identification ID: {selectedUserData.User.other5}
          <p>
            User status: <span className={statusClass}>{userStatus}</span>
          </p>
        </div>
        {personalIdImage != null && personalIdImage.length > 0 ? (
          <KYCItem
            docType={
              classification[
                kycData.payload[1].body.record.Userkycdocs.doctype
              ] ?? "Identification"
            }
            status={getStatus(idStatus)}
            onReadDocument={() => readDocument(personalIdImage, "personalID")}
            onPending={() =>
              setStatus(kycData.payload[1].body.record.Userkycdocs, 0)
            }
            onAccept={() =>
              setStatus(kycData.payload[1].body.record.Userkycdocs, 1)
            }
            onReject={() =>
              setStatus(kycData.payload[1].body.record.Userkycdocs, -1)
            }
            onSelect={() => setIdVisible(!idVisible)}
          />
        ) : (
          <KYCNoItem
            docType="Identification"
            selectedUser={selectedUser}
            groupid={1}
            docname={"identification"}
            setKycData={setKycData}
          />
        )}
        {idVisible && (
          <KYCInformation
            selectedImage={idImageSelected}
            selectedUser={selectedUser}
            groupid={1}
            docname={"identification"}
            setKycData={setKycData}
            hideDocNumber={false}
            docNumber={selectedUserData.User.other5}
            displayPDF={false}
          />
        )}

        {addressImage != null && addressImage.length > 0 ? (
          <KYCItem
            docType={"Proof of Address"}
            status={getStatus(addressStatus)}
            onReadDocument={() => readDocument(addressImage, "address")}
            onPending={() =>
              setStatus(kycData.payload[2].body.record.Userkycdocs, 0)
            }
            onAccept={() =>
              setStatus(kycData.payload[2].body.record.Userkycdocs, 1)
            }
            onReject={() =>
              setStatus(kycData.payload[2].body.record.Userkycdocs, -1)
            }
            onSelect={() => setAddressVisible(!addressVisible)}
          />
        ) : (
          <KYCNoItem
            docType="Proof of Address"
            selectedUser={selectedUser}
            groupid={2}
            docname={"address"}
            setKycData={setKycData}
          />
        )}
        {addressVisible && (
          <KYCInformation
            selectedImage={addressImageSelected}
            selectedUser={selectedUser}
            groupid={2}
            docname={"address"}
            setKycData={setKycData}
            hideDocNumber={true}
            displayPDF={false}
          />
        )}
        {selfieImage != null && selfieImage.length > 0 ? (
          <KYCItem
            docType={"Selfie"}
            status={getStatus(selfieStatus)}
            onReadDocument={() => readDocument(selfieImage, "selfie")}
            onPending={() =>
              setStatus(kycData.payload[3].body.record.Userkycdocs, 0)
            }
            onAccept={() =>
              setStatus(kycData.payload[3].body.record.Userkycdocs, 1)
            }
            onReject={() =>
              setStatus(kycData.payload[3].body.record.Userkycdocs, -1)
            }
            onSelect={() => setInfoVisible(!infoVisible)}
          />
        ) : (
          <KYCNoItem
            docType="Selfie"
            selectedUser={selectedUser}
            groupid={3}
            docname={"selfie"}
            setKycData={setKycData}
          />
        )}
        {selfieSelected && infoVisible && (
          <KYCInformation
            selectedImage={selfieSelected}
            selectedUser={selectedUser}
            groupid={3}
            docname={"selfie"}
            setKycData={setKycData}
            hideDocNumber={true}
            displayPDF={false}
          />
        )}
        {
          licenseImage != null && licenseImage.length > 0 ? (
            <KYCItem
              docType="Driver’s License"
              onReadDocument={() => readDocument(personalIdImage, "license")}
              onPending={() =>
                setStatus(kycData.payload[3].body.record.Userkycdocs, 0)
              }
              onAccept={() =>
                setStatus(kycData.payload[3].body.record.Userkycdocs, 1)
              }
              onReject={() =>
                setStatus(kycData.payload[3].body.record.Userkycdocs, -1)
              }
              onSelect={() => setInfoVisible(!infoVisible)}
            ></KYCItem>
          ) : (
            <></>
          )
          // (<KYCNoItem
          //   docType="Driver’s License"
          // />)
        }
        {selectedImageType === "license" && infoVisible && (
          <KYCInformation selectedImage={licenseSelected} />
        )}
        <div
          className="approve-buttons"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div>
            {displayMessage && userStatus === "Accepted" && (
              <p>User has been approved</p>
            )}
          </div>
          <div>
            {displayMessage && userStatus === "Rejected" && (
              <p>User has been rejected</p>
            )}
          </div>
          <button className="kyc-compare" onClick={() => validateUser(2)}>
            Approve
          </button>
          <button className="kyc-compare" onClick={() => validateUser(0)}>
            Reject
          </button>
        </div>

        {/* <div className="ofac-container">
          <div className="text-container">
            <p className="ofac-text">OFAC Check</p>
            <p className="last-updated">Last Updated: YYYY-MM-DD</p>
          </div>
          <button className="run-button">Run</button>
          <input type="checkbox" className="ofac-checkbox" id="all" />
          <label for="all">All</label>
          <input type="checkbox" className="ofac-checkbox" id="name" />
          <label for="name">Name</label>
          <input type="checkbox" className="ofac-checkbox" id="dob" />
          <label for="dob">DOB</label>
          <input type="checkbox" className="ofac-checkbox" id="gender" />
          <label for="gender">Gender</label>
          <input type="checkbox" className="ofac-checkbox" id="nationality" />
          <label for="nationality">Nationality</label>
          <div className="drop-down-container">
            <p className="drop-down-text">Record Type</p>
            <select name="recordType" id="recordType">
              <option value="All">All</option>
            </select>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default KYC;
